import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker } from 'components';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { Menu as MenuIcons, CompanyIcon } from 'assets/icons';
import { RouteComponentProps } from 'react-router-dom';
import { InformationService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Home extends React.Component<Props> {

	state = {
		form: {
			company_name: '',
			welcome_message: '',
		},
		agents: []
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await InformationService.getData({
			user_id: this.props.user?.id
		});
		this.setState({
			agents: res.agents || [],
			form: {
				...this.state.form,
				company_name: res.person?.company_name || '',
				welcome_message: res.person?.welcome_message || ''
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		await InformationService.updateCompanyData({
			...this.state.form
		});
		Globals.showSuccess("Se ha modificado correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	render() {
		return (
			<div id="client-agent-home">
				<form onSubmit={ this.submit } className="form-black">
					<Input
						value={ this.state.form.company_name }
						name="company_name"
						placeholder="Escribir"
						label="¿Cuál es el nombre de tu Empresa?"
						onChange={ (e: any) => this.change(e) } />
					<Textarea
						rows={ 8 }
						value={ this.state.form.welcome_message }
						name="welcome_message"
						placeholder="Escribir"
						label="Mensaje de bienvenida"
						onChange={ (e: any) => this.change(e) } />
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Home);